module.exports = __webpack_public_path__ + "static/media/5m.20604677.png";